module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-art-performance.svg?0a71e02b07aa0d930461e73834070de0";